import { MdEmail, MdOutlineWhatsapp } from 'react-icons/md';
import { contactDetails } from '../HospiumContent';
import logoWorded from '../assets/logo_worded.png';

export default function ContactUsContent() {
  return (
    <main className="HospiumContactPage">
      <div className="container">
        <div className="HospiumContactShell">
          <section className="HospiumContactIntro">
            <img src={logoWorded} alt="Hospium" />
            <span className="HospiumKicker">Place an inquiry</span>
            <h1>Let’s talk about your healthcare operation.</h1>
            <p>Whether you manage a hospital, clinic, or pharmacy, tell us what you want to improve. We’ll help you identify the Hospium product that fits your current needs.</p>
            <div className="HospiumContactNotes"><span>Hospitals and clinics</span><span>Independent pharmacies</span><span>Patient identity and telehealth</span></div>
          </section>
          <section className="HospiumContactActions">
            <h2>Choose how you want to reach us</h2>
            <p>We respond directly through the channel you select.</p>
            <a className="HospiumContactButton is-whatsapp" href={contactDetails.whatsappUrl} target="_blank" rel="noreferrer"><MdOutlineWhatsapp /><span><small>Chat with us on WhatsApp</small>{contactDetails.whatsappDisplay}</span></a>
            <a className="HospiumContactButton is-email" href={`mailto:${contactDetails.email}?subject=Hospium%20product%20inquiry`}><MdEmail /><span><small>Send us an email</small>{contactDetails.email}</span></a>
          </section>
        </div>
      </div>
    </main>
  );
}
